import VehicleSelectDetailsCardContainer from './VehicleSelectDetailsCardContainer';

export default VehicleSelectDetailsCardContainer;
